import { useRef, useState } from 'react'

interface Props {
  onFiles: (files: File[]) => void
  compact?: boolean
}

export function UploadZone({ onFiles, compact = false }: Props) {
  const inputRef = useRef<HTMLInputElement>(null)
  const [dragging, setDragging] = useState(false)

  const acceptFiles = (list: FileList | null) => {
    if (!list) return
    const files = [...list].filter((file) => file.type.startsWith('image/') || /\.(jpe?g|png|webp|heic|heif)$/i.test(file.name))
    if (files.length) onFiles(files)
  }

  return (
    <div
      className={`upload-zone ${compact ? 'compact' : ''} ${dragging ? 'dragging' : ''}`}
      onDragEnter={(event) => { event.preventDefault(); setDragging(true) }}
      onDragOver={(event) => { event.preventDefault(); event.dataTransfer.dropEffect = 'copy' }}
      onDragLeave={(event) => { if (event.currentTarget === event.target) setDragging(false) }}
      onDrop={(event) => { event.preventDefault(); setDragging(false); acceptFiles(event.dataTransfer.files) }}
    >
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif"
        multiple
        onChange={(event) => { acceptFiles(event.target.files); event.currentTarget.value = '' }}
      />
      <button className="upload-button" type="button" onClick={() => inputRef.current?.click()}>
        <span className="upload-glyph" aria-hidden="true"><i /><i /></span>
        <span className="upload-copy">
          <strong>{compact ? '写真を追加' : '写真を選ぶ'}</strong>
          {!compact && <small>パソコンから選ぶ、ここへ置く、または貼り付け</small>}
        </span>
      </button>
      {!compact && (
        <div className="upload-spec">
          <span>JPEG</span><span>PNG</span><span>WebP</span><span>HEIC</span><span>1枚80MBまで</span>
        </div>
      )}
    </div>
  )
}
